import { render, staticRenderFns } from "./ModalRecFacial.vue?vue&type=template&id=e665fee8&scoped=true"
import script from "./ModalRecFacial.vue?vue&type=script&lang=js"
export * from "./ModalRecFacial.vue?vue&type=script&lang=js"
import style0 from "./ModalRecFacial.vue?vue&type=style&index=0&id=e665fee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e665fee8",
  null
  
)

export default component.exports